import { render, staticRenderFns } from "./Gstr1Tab.vue?vue&type=template&id=ce7d4470&"
import script from "./Gstr1Tab.vue?vue&type=script&lang=js&"
export * from "./Gstr1Tab.vue?vue&type=script&lang=js&"
import style0 from "./Gstr1Tab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports